import { PhoneFormatDir } from "../../data/phoneFormat";
import { ApiData } from "../../data/apiData";
import { Curs, Curses } from "../../data/currencyRates";
import { PasswordRequirements } from "../../data/passwordRequirements";
import { ProductData } from "../../data/productData";
import { LoginModel } from "../../models/auth/LoginModel";
import { clientTime } from "../../utilities/index";
import { Http } from "./http";

/**Запросы к методам получения настроек с сервера */
export class ConfigApi {
  /**
   * Получение данных API
   * @returns Объект ApiData
   */
  static async syncApiState(): Promise<ApiData> {
    const respData = await Http.get("WebClient/ApiState");

    return new ApiData(respData?.data);
  }

  static async getSubscriptionCategoryImages(
    categoryPath : string
  ): Promise<Array<any>> {    
    const respData: any = await Http.sendData(categoryPath, true, null);

    return respData?.data ?? [];

  }

  static async getCashBackPage(): Promise<any> {
    const respData = await Http.sendData("Pay2U/GetView", true, null);

    return respData;
  }

  static async getCashBackUrl(): Promise<string> {
    const respData = await Http.get("Pay2U/GetUrl");

    if (respData.result === 'ok')
      return respData.message;
    return '';
  }

  /**
   * Получение требований к паролю.
   * @returns Требования к паролю
   */
  static async getPasswordRequirementsAsync(): Promise<PasswordRequirements> {
    const respData = await Http.get("WebClient/GetPasswordRequirements");

    return new PasswordRequirements(respData?.data);
  }

  /**
   * Получение списка продуктов.
   * @returns Cписок продуктов.
   */
  static async getProductsAsync(
    productsFile: any
  ): Promise<Array<ProductData>> {
    const rc = new Array<ProductData>();

    const respData = await Http.sendData(productsFile, true, null);

    const products = respData?.data?.products;
    if (products == null) return rc;

    products.forEach((product: any) => {
      if (
        !rc.find((pr: any) => product.caption && pr.Caption === product.caption)
      )
        rc.push(new ProductData(product));
    });

    return rc;
  }

  static async fetchPhoneFormatDir(
    phoneFormatDirFile: any
  ): Promise<PhoneFormatDir> {
    const respData = await Http.sendData(phoneFormatDirFile, true, null);

    if (!respData?.data?.FormatDict) return new PhoneFormatDir();

    return new PhoneFormatDir(respData.data);
  }

  /**
  * Загрузка курса валют банка
  * @param currCode код валюты
  * @returns курсы банка
  */
  public static async getCurrencyRatesAsync(currCode: string): Promise<Curses> {
    const respData = await Http.get(
      `WebClient/GetCurrencyRates?currency=${currCode}&&clientTime=${clientTime()}&typeSource=0`
    );
    
    return new Curses(respData?.data);
  }
}
